<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="data !== null">
    <InputRadio
        v-model="data"
        :options="booleanYesNo"
        :db="db"
        :args="args"
        :skipped="skipped"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { willRelationshipHelpers } from "../../../../fieldsets/will/helpers/willRelationshipHelpers";
import { willPeopleHelpers } from "../../../../fieldsets/will/helpers/willPeopleHelpers";
import { questionLoadHelpers } from "../../../helpers/questionLoadHelpers";
import { general } from "../../../options/general";
import {personHelpers} from "@/mixins/personHelpers";

import QuestionBase from "../../../QuestionBase";
import InputRadio from "../../../inputs/InputRadio";

export default {
  name: 'BackupYN',
  mixins: [general, questionLoadHelpers, willPeopleHelpers, willRelationshipHelpers, personHelpers],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: [Boolean],
      required: false
    },
    details: {
      type: Object,
      required: false
    },
    callbackFunction: {
      type: Function,
      required: true
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    },
    question() {
      return {
        title: 'Would you like to name backup Trustees?',
        subTitle: `You have named ${this.listPeopleAddressDob({people: this.details.primary, noDob: true})} as your main ${this.oneOrMore({
          list: this.details.primary,
          word: 'Trustee'
        })} and you have named ${this.listPeopleAddressDob({people: this.details.secondary, noDob: true})} as a secondary ${this.oneOrMore({
          list: this.details.primary,
          word: 'Trustee'
        })}. You can go further and appoint a final person (or persons) if all else fails.`,
        tip: null,
      }
    },
  },
  data () {
    return {
      db: {
        saveLocation: 'product_will_data',
        saveField: 'backupYNTrustees',
        formPath: 'data.trustees.details.backupYN',
        jsonSaveField: 'backupYN',
        callbackFunction: this.callbackFunction
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
